export const ENGLISH_LANGUAGE = {
    translation: {
        header: {
            items: [
                { name: 'Home', link: '/#home' },
                { name: 'About me', link: '/#about' },
                { name: 'Technologies', link: '/#services' },
                { name: 'Projects', link: '/#portfolio' },
                { name: 'Contacts', link: '/#contact' },
            ]
        },
        home: {
            presentation: "Hey there,",
            whoIsIt: "I'm Gabriel!!",
            occupation: "Front-end Developer",
            invite: "Let's talk",
            invitationLink: 'https://wa.me/5511960188549?text=Hello%2C%20I%20want%20to%20know%20more%20about%20you'
        },
        aboutMe: {
            title: "About me",
            firstSentence: "I'm a full stack developer, but currently I've been working as a front-end developer at Zenvia company.",
            secondSentence: "I'm studying computer science at Anhembi Morumbi University. I graduated in Information Systems at Etec in Embu das Artes",
            thirdSentence: "In my routine I use these technologies",
            resumeButton: 'check my resume',
            linkMyResume: 'https://drive.google.com/file/d/1Xijod7iWw9a412hJ8uF5r6pq9yTs8lXy/view?usp=sharing'
        },
        technologies: {
            title: 'Technologies',
            subtitle: 'Check the technologies I use the most',
            listTechnologies: [
                { id: '1', name: 'Next JS', description: 'React framework for production with focus on efficiency, created and maintained by Vercel.' },
                { id: '2', name: 'TypeScript', description: "TypeScript adds syntax to JavaScript for tighter editor integration and catches errors early." },
                { id: '3', name: 'Sass', description: "Sass is a CSS pre-processor. It's fully compatible with all versions of CSS." },
                { id: '4', name: 'React Js', description: 'Library for building user interfaces (UI).' },
                { id: '5', name: 'React Native', description: 'Framework for building native Android and iOS applications.' },
                { id: '6', name: 'PostgreSQL', description: 'Powerful, open source object-relational database with SQL, ACID compliance, and extensibility.' },
                { id: '7', name: 'MySQL', description: "World's most popular open source database. Proven performance, reliability and ease-of-use for web applications." },
                { id: '8', name: 'MongoDB', description: 'Document database that stores data in flexible, JSON-like documents with horizontal scaling and high availability.' },
                { id: '9', name: 'NestJS', description: 'Framework for building efficient, scalable Node.js server-side applications with TypeScript and out-of-the-box architecture.' },
                { id: '10', name: 'Docker', description: 'Open platform for developing, shipping and running applications in lightweight, isolated containers.' },
                { id: '11', name: 'CI/CD', description: 'Practice that automates building, testing and deploying code for faster, more reliable releases.' },
                { id: '12', name: 'GraphQL', description: 'Query language and runtime for APIs. Enables flexible APIs with a strong type system.' },
                { id: '13', name: 'Kubernetes', description: 'Portable, open source platform for managing containerized workloads with declarative config and automation.' },
                { id: '14', name: 'Monorepo (Nx/Turborepo)', description: 'Tools for managing codebases at scale: fast task caching, intelligent orchestration and parallel execution.' },
                { id: '15', name: 'Serverless', description: 'Run code without provisioning or managing servers; automatic scaling and pay-per-use.' },
                { id: '16', name: 'Micro frontends', description: 'Architecture where frontends are built and deployed independently and composed into a single application.' },
                { id: '17', name: 'AWS', description: "World's most comprehensive and broadly adopted cloud platform. Compute, storage, databases and 200+ services on-demand at scale." },
            ]
        },
        projects: {
            title: 'Personal Projects',
            subtitle: 'Check my projects',
        },
        contact: {
            title: 'Contacts',
            subtitle: 'Contact me to start chatting',
            location: 'Location',
            email: 'Email',
            phone: 'Phone number',
        },
        network: {
            title: 'Where you can find me'
        }
    }
};
